/** Local-day helpers. Check-ins are keyed by the client's local YYYY-MM-DD
 *  so "done today" doesn't drift across time zones. */

export function todayKey(date: Date = new Date()): string {
  return dayKey(date);
}

export function dayKey(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function parseDay(key: string): Date {
  const [y, m, d] = key.split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function addDays(d: Date, n: number): Date {
  const copy = new Date(d);
  copy.setDate(copy.getDate() + n);
  return copy;
}

/** Return array of YYYY-MM-DD for the last `days` days (oldest first),
 *  ending at `today`. */
export function lastNDays(days: number, today: Date = new Date()): string[] {
  const out: string[] = [];
  for (let i = days - 1; i >= 0; i--) out.push(dayKey(addDays(today, -i)));
  return out;
}

/** Return the first day (inclusive) of the week containing `d`, week starts Sunday. */
export function startOfWeek(d: Date): Date {
  const copy = new Date(d);
  copy.setHours(0, 0, 0, 0);
  copy.setDate(copy.getDate() - copy.getDay());
  return copy;
}

export function startOfMonth(d: Date): Date {
  return new Date(d.getFullYear(), d.getMonth(), 1);
}

export function endOfMonth(d: Date): Date {
  return new Date(d.getFullYear(), d.getMonth() + 1, 0);
}

const MONTH_LABELS = [
  'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
  'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC',
];

/** Fantasy month label — maps real month → "AUTUMN · MOON N" (design flavor). */
export function monthLabel(d: Date): string {
  return `${MONTH_LABELS[d.getMonth()]} ${d.getFullYear()}`;
}

export function prettyDate(iso: string): string {
  const d = new Date(iso);
  return `${MONTH_LABELS[d.getMonth()].slice(0, 3).charAt(0)}${MONTH_LABELS[d.getMonth()].slice(1, 3).toLowerCase()} ${d.getDate()}`;
}

/** "Apr 28" from a YYYY-MM-DD key (no timezone round-trip). */
export function prettyDay(key: string): string {
  const d = parseDay(key);
  return `${MONTH_LABELS[d.getMonth()].charAt(0)}${MONTH_LABELS[d.getMonth()].slice(1, 3).toLowerCase()} ${d.getDate()}`;
}
